import { axiosInstance } from './apiConfig';
import { LOCAL_STORAGE_TOKEN_NAME } from '../constants';

export const apiLogin = async () => {
    try {
        const response = await axiosInstance.post('/login', {});
        await localStorage.setItem(LOCAL_STORAGE_TOKEN_NAME, response.data.access_token);
    } catch (error) {
        console.log('Error getting token', error);
    }
}


// WEBPACK FOOTER //
// ./src/api/login.js